var _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 36,
    height: 36,
    rx: 4,
    fill: "#F1F1F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 7,
    width: 18,
    height: 8,
    rx: 2,
    fill: "#E91B29"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6901 33C22.7441 33 22.7801 32.964 22.7801 32.91V30.867C22.7801 30.831 22.7981 30.813 22.8341 30.813H23.9231C25.2461 30.813 26.0561 30.003 26.0561 28.851C26.0561 27.681 25.2551 26.88 23.9231 26.88H21.5471C21.4931 26.88 21.4571 26.916 21.4571 26.97V32.91C21.4571 32.964 21.4931 33 21.5471 33H22.6901ZM23.8421 29.67H22.8341C22.7981 29.67 22.7801 29.652 22.7801 29.616V28.077C22.7801 28.041 22.7981 28.023 22.8341 28.023H23.8421C24.4001 28.023 24.7331 28.356 24.7331 28.851C24.7331 29.346 24.4001 29.67 23.8421 29.67ZM26.9063 32.91C26.9063 32.964 26.9423 33 26.9963 33H29.2733C30.3443 33 31.0913 32.541 31.3883 31.623C31.4963 31.281 31.5503 30.939 31.5503 29.94C31.5503 28.941 31.4963 28.599 31.3883 28.257C31.0913 27.339 30.3443 26.88 29.2733 26.88H26.9963C26.9423 26.88 26.9063 26.916 26.9063 26.97V32.91ZM28.2293 31.767V28.113C28.2293 28.077 28.2473 28.059 28.2833 28.059H28.9763C29.5883 28.059 29.9573 28.239 30.1103 28.734C30.1733 28.914 30.2093 29.148 30.2093 29.94C30.2093 30.732 30.1733 30.966 30.1103 31.146C29.9573 31.641 29.5883 31.821 28.9763 31.821H28.2833C28.2473 31.821 28.2293 31.803 28.2293 31.767ZM32.5752 32.91C32.5752 32.964 32.6112 33 32.6652 33H33.8082C33.8622 33 33.8982 32.964 33.8982 32.91V30.606C33.8982 30.57 33.9162 30.552 33.9522 30.552H36.1482C36.2022 30.552 36.2382 30.516 36.2382 30.462V29.508C36.2382 29.454 36.2022 29.418 36.1482 29.418H33.9522C33.9162 29.418 33.8982 29.4 33.8982 29.364V28.077C33.8982 28.041 33.9162 28.023 33.9522 28.023H36.5892C36.6432 28.023 36.6792 27.987 36.6792 27.933V26.97C36.6792 26.916 36.6432 26.88 36.5892 26.88H32.6652C32.6112 26.88 32.5752 26.916 32.5752 26.97V32.91Z",
    fill: "#787A8F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocPdf);
export default __webpack_public_path__ + "static/media/doc-pdf.3065b27e.svg";
export { ForwardRef as ReactComponent };